
//68
Object.defineProperty(exports, "__esModule", { value: true });
require("../theme.st.css");
require("../../../components/avatar/avatar.st.css");
require("../colors.st.css");
require("../text.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "avatar1000189677",
    {"avatar":"avatar1000189677--avatar","colorBlue":"avatar1843822884--colorBlue","colorGreen":"avatar1843822884--colorGreen","colorGrey":"avatar1843822884--colorGrey","colorRed":"avatar1843822884--colorRed","colorOrange":"avatar1843822884--colorOrange","size90":"avatar1843822884--size90","size72":"avatar1843822884--size72","size60":"avatar1843822884--size60","size48":"avatar1843822884--size48","size36":"avatar1843822884--size36","size30":"avatar1843822884--size30","size24":"avatar1843822884--size24","size18":"avatar1843822884--size18","root":"avatar1000189677--root"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/themes/backoffice/avatar/avatar.st.css
// module id = 1359
// module chunks = 0